<template>
    <div class="step-list steps-wait" style="width: 33.3333%;">
        <div class="steps-tail">
            <i></i>
        </div>
        <div class="steps-head">
            <div>
                <span>{{num}}</span>
            </div>
        </div>
        <div class="steps-main">
            <div class="steps-title">{{title}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                num: '',
                currentStatus: ''
            }
        },
        props: {
            title: String
        }
    }
</script>

<style lang="scss" scoped>
    .steps-head, .steps-main {
        position: relative;
        display: inline-block;
        vertical-align: top;
    }

    .steps-content {
        display: none;
        position: absolute;
        z-index: 2;
        width: 250px;
    }

    .step-list {
        margin: 0;
        padding: 0;
        width: 33.3333%;
        position: relative;
        display: inline-block;
        vertical-align: top;
        &.steps-finish {
            &:hover {
                .steps-content {
                    display: block;
                }
            }
            .steps-tail {
                i {
                    background: #0084ff;
                    height: 2px;
                }
            }
            .steps-head {
                background: #fff;
                div {
                    background: #0084ff;
                    color: #fff;
                    border: 1px solid #0084ff;
                    span {
                        color: #fff;
                    }
                }
            }
            .steps-main {
                .steps-title {
                    color: #666;
                    background: #fff;
                }
                .steps-content {
                    color: #5E6D82;
                    background: #FFFFFF;
                    padding: 5% 8%;
                }
            }
        }
            &.steps-none{
                .steps-tail{
                    display: none;
                }

             }
        &.steps-process {
            .steps-tail {
                i {
                    background: #e9eaec;
                }
            }
            .steps-head {
                background: #fff;
                div {
                    background: #0084ff;
                    border: 1px solid #0084ff;
                    span {
                        color: #fff;
                    }
                }
            }
        }
        .steps-tail {
            width: 100%;
            padding: 0 10px;
            position: absolute;
            left: 0;
            top: 13px;
            i {
                display: inline-block;
                width: 100%;
                height: 1px;
                vertical-align: top;
                background: #e9eaec;
                border-radius: 1px;
                position: relative;
            }
        }
        .steps-head {
            background: #fff;
            div {
                display: block;
                width: 26px;
                height: 26px;
                background: #fff;
                line-height: 24px;
                margin-right: 8px;
                text-align: center;
                border: 1px solid #ccc;
                border-radius: 50%;
                font-size: 14px;
                transition: background-color .2s ease-in-out;
                span {
                    color: #ccc
                }
            }
        }
        .steps-main {
            margin-top: 2.5px;
            display: inline;
            .steps-title {
                margin-bottom: 4px;
                padding-right: 10px;
                font-size: 14px;
                color: #999;
                background: #fff;
            }
        }
    }


</style>



// WEBPACK FOOTER //
// Step.vue?316bdda4